const TTS_API_URL = "http://10.117.253.234:5003/tts/stream";

async function decodeAndPlay(audioContext, pcmData, startTime) {
  try {
    const int16Array = new Int16Array(pcmData.buffer, pcmData.byteOffset, pcmData.length / 2);
    const float32Array = new Float32Array(int16Array.length);

    for (let i = 0; i < int16Array.length; i++) {
      float32Array[i] = int16Array[i] / 32768.0;
    }

    const audioBuffer = audioContext.createBuffer(1, float32Array.length, 24000);
    audioBuffer.getChannelData(0).set(float32Array);

    const source = audioContext.createBufferSource();
    source.buffer = audioBuffer;
    source.connect(audioContext.destination);

    return new Promise((resolve) => {
      source.onended = resolve;
      source.start(startTime);
    });
  } catch (error) {
    console.error('Error decoding/playing audio chunk:', error);
  }
}


export const playTextToSpeechRealtime = async (text, language = 'fr') => {
  const response = await fetch(TTS_API_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ text, language }),
  });

  if (!response.ok) {
    throw new Error(`TTS API failed with status: ${response.status}`);
  }

  const audioContext = new (window.AudioContext || window.webkitAudioContext)({
    sampleRate: 24000,
    latencyHint: 'interactive' 
  });

  if (audioContext.state === 'suspended') {
    await audioContext.resume();
  }

  const reader = response.body.getReader();
  let buffer = new Uint8Array();
  let isFirstChunk = true;
  
  const HEADER_SIZE = 44;
  const MIN_CHUNK_SIZE = 96000; 
  const BYTES_PER_SAMPLE = 2;
  
  let nextStartTime = audioContext.currentTime + 0.2;
  const playPromises = [];

  while (true) {
    const { done, value } = await reader.read();

    if (value) {
      const dataToAdd = isFirstChunk ? value.slice(HEADER_SIZE) : value;
      isFirstChunk = false;

      const newBuffer = new Uint8Array(buffer.length + dataToAdd.length);
      newBuffer.set(buffer);
      newBuffer.set(dataToAdd, buffer.length);
      buffer = newBuffer;

      while (buffer.length >= MIN_CHUNK_SIZE) {
        const chunkToPlay = buffer.slice(0, MIN_CHUNK_SIZE);
        buffer = buffer.slice(MIN_CHUNK_SIZE);

        if (nextStartTime < audioContext.currentTime) {
          nextStartTime = audioContext.currentTime + 0.1;
        }

        const playPromise = decodeAndPlay(audioContext, chunkToPlay, nextStartTime);
        playPromises.push(playPromise);

        const duration = chunkToPlay.length / (24000 * BYTES_PER_SAMPLE);
        nextStartTime += duration;
      }
    }

    if (done) {
      if (buffer.length > 0) {
        if (nextStartTime < audioContext.currentTime) {
          nextStartTime = audioContext.currentTime + 0.1;
        }
        const playPromise = decodeAndPlay(audioContext, buffer, nextStartTime);
        playPromises.push(playPromise);
      }
      break;
    }
  }

  await Promise.all(playPromises);
  await audioContext.close();
};


export const textToSpeechAPI = async (text, language = 'fr') => {
  const response = await fetch(TTS_API_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ text, language }),
  });

  if (!response.ok) {
    throw new Error(`TTS API failed with status: ${response.status}`);
  }

  return response.blob();
};